import React, { Component } from 'react';
import { withRouter } from 'react-router'
import Constants from './Constants.js';
import $ from 'jquery';
import numeral from 'numeral';

class ScheduleDemoFunnel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      data: []
    };
  }	
  componentWillMount() {
  	const self = this;

		$.ajax({
      type: 'GET',
      url: `${Constants.API_HOST}metrics/schedule_demo_funnel/`,
      contentType: 'application/json',
      dataType: "json",
      xhrFields: { withCredentials:true },
      success: function success(data) {
      	self.setState({
      		'data': data
      	})

      },
      error: function error(data) {

      }
    });

  }	

  render() {
    if (this.state.data.length === 0) {
      return (
        <p>Loading...</p>
      )
    }

    let self = this;
    let dates = this.state.data.meta.dates;

    return (
      <div>
      	<h1>Schedule Demo Funnel</h1>

        {
          dates.map(function(d) {


            console.log( self.state.data.data[d].steps );
            return (
              <div key={d}>
                <h4>{ d }</h4>

                <table className="table">
                  <thead>
                    <tr>
                      <th>
                        Event
                      </th>
                      <th>
                        Count
                      </th>
                      <th>
                        Step Conversion Ratio
                      </th>
                      <th>
                        Overall Conversion Ratio
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                  {

                    self.state.data.data[d].steps.map(function(step) {
                      return (
                        <tr key={step.event}>
                          <td>
                            { step.event }
                          </td>
                          <td>
                            { step.count }
                          </td>
                          <td>
                            { numeral(step.step_conv_ratio).format('0.00%') }
                          </td>
                          <td>
                            { numeral(step.overall_conv_ratio).format('0.00%') }
                          </td>
                        </tr>
                      )
                    })
                  }
                  </tbody>

                </table>
              </div>
            )
          })
        }



      </div>
    );
  }
}

export default withRouter(ScheduleDemoFunnel);


// WEBPACK FOOTER //
// ./src/components/ScheduleDemoFunnel.js